module.exports = __webpack_public_path__ + "img/popover-box-bg.614a311b.png";